module.exports = __webpack_public_path__ + "media/images/badges/bft-badge-8137ecccec53b15076ae642adbddcd5c.png";